import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Talents Feature Slice
 * 
 * Manages local UI state for talents (filters, view mode, etc.)
 * Data fetching is handled by RTK Query in services/api/endpoints/talents.ts
 */

interface TalentsState {
  filters: {
    category?: string;
    searchQuery?: string;
  };
  viewMode: 'grid' | 'list';
  selectedTalentId: string | null;
}

const initialState: TalentsState = {
  filters: {},
  viewMode: 'grid',
  selectedTalentId: null,
};

const talentsSlice = createSlice({
  name: 'talents',
  initialState,
  reducers: {
    setCategoryFilter: (state, action: PayloadAction<string | undefined>) => {
      state.filters.category = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string | undefined>) => {
      state.filters.searchQuery = action.payload;
    },
    clearFilters: (state) => {
      state.filters = {};
    },
    setViewMode: (state, action: PayloadAction<'grid' | 'list'>) => {
      state.viewMode = action.payload;
    },
    setSelectedTalent: (state, action: PayloadAction<string | null>) => {
      state.selectedTalentId = action.payload;
    },
  },
});

export const {
  setCategoryFilter,
  setSearchQuery,
  clearFilters,
  setViewMode,
  setSelectedTalent,
} = talentsSlice.actions;

export default talentsSlice.reducer;

